/**
 * "Additional Documents" accordion on the combined report (client
 * 2026-09-08): one row per member, expanding to the SAME document rows the
 * individual page's Additional Documents card renders (AdditionalDocumentsBody
 * — configured checklist + uploads, or uploads only for legacy apps). Hidden
 * entirely when no member has anything to list, like the individual card.
 */
import { deriveMemberDocumentSummary } from '#app/utils/application-detail-v2/combined-display'
import type {
	GroupMember,
	MemberDocuments as MemberDocumentsView,
} from '#app/utils/application-detail-v2/types'
import { SectionIcon } from '../primitives'
import { AdditionalDocumentsBody } from '../sections/AdditionalDocuments'
import { MemberAccordion } from './MemberAccordion'

export function MemberDocuments({
	members,
	memberDocuments,
}: {
	members: GroupMember[]
	memberDocuments: Record<string, MemberDocumentsView>
}) {
	const viewOf = (member: GroupMember): MemberDocumentsView =>
		memberDocuments[member.applicationId] ?? {
			documents: [],
			requiredItems: null,
		}
	if (
		!members.some(
			(member) => deriveMemberDocumentSummary(viewOf(member)).hasContent,
		)
	) {
		return null
	}
	return (
		<MemberAccordion
			title="Additional Documents"
			icon={<SectionIcon src="/img/additional-document-icon.svg" />}
			members={members}
			row={(member) => {
				const view = viewOf(member)
				const summary = deriveMemberDocumentSummary(view)
				// No "N of M uploaded" summary on the row (client 2026-09-09) — the
				// chevron alone; the rows inside carry the per-document state.
				return {
					expandable: summary.hasContent,
					summary: null,
					body: (
						<AdditionalDocumentsBody
							documents={view.documents}
							requiredItems={view.requiredItems}
							className="pb-4"
						/>
					),
				}
			}}
		/>
	)
}
